import Vue from 'vue'
import Router, {RawLocation} from 'vue-router'
import { constRoutes } from './subRouter/constRoutes'


/*
  redirect:                      if set to 'noredirect', no redirect action will be trigger when clicking the breadcrumb
  meta: {
    title: 'title'               the activeMenu showed in subMenu and breadcrumb (recommend set)
    icon: 'svg-activeMenu'             the icon showed in the sidebar
    breadcrumb: false            if false, the item will be hidden in breadcrumb (default is true)
    hidden: true                 if true, this route will not show in the sidebar (default is false)
  }
*/

Vue.use(Router)
const VueRouterPush = Router.prototype.push
Router.prototype.push = function push (to: RawLocation) {
  return (VueRouterPush.call(this, to) as any).catch((err: any) => err)
}

const createRouter = () => new Router({
  mode: 'history',
  scrollBehavior: (to, from, savedPosition) => {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  base: '/amc',
  routes: constRoutes
})
console.log('process.env.BASE_URL', process.env.BASE_URL)

const router = createRouter()

export function resetRouter () {
  const newRouter = createRouter();
  (router as any).matcher = (newRouter as any).matcher // reset router
}

export default router
